import { UPQuestionAssessmentResponse, QuidQuestionMode } from 'up';

export interface QuestionAssessmentState {
  questionAssessmentInfo: UPQuestionAssessmentResponse[];
}

export const initialQuestionAssessmentState: QuestionAssessmentState = {
  questionAssessmentInfo: [],
};
